import { Box, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import "./about.css"
import profile from "../../assets/profile.jpg";
import {VscLocation} from "react-icons/vsc";
import {GiMagicHat} from "react-icons/gi";
import {BsMusicNoteBeamed, BsArrowDown ,BsListNested} from "react-icons/bs";
import {AiOutlineRobot, AiOutlineSchedule} from "react-icons/ai"
import {BiMessageSquareDots, BiMailSend} from "react-icons/bi"

const About = () => {
  return (
    <div>
        <section className='home'>
    <Box className='container' height={["150vh","100vh"]}>
    <Stack 
             direction={["column","row"]}
             height="100%"
             justifyContent={["center","space-between"]}
             alignItems={"center"}
             spacing={["16","56"]} >
              <VStack width="full" alignItems={["left","flex-start"]} className='v-container' spacing={"5"}>
                    <Heading children="Pixels – People – Products – Places – Pizza." fontWeight={'semibold'} color={'#362FD9'} maxW={'2xl'}/>
                    <Text  children="Heya! I am Avi Bhawnani,  I was born and brought up in the northern part of the beautiful country of India. Ever since I was a kid, I have spent my time creating things – from a mini roller coaster to automobile sketches." fontSize={"xl"}  letterSpacing={2} maxW={"2xl"} textAlign="justify"/>
                    <Box  maxW={'4xl'} display={'flex'} paddingTop={5}>
                        <Box >
                        <span style={{justifyContent:"flex",display:"flex"}}>
                            <VscLocation size={18} color='grey' style={{margin:"3"}}></VscLocation>
                            <Text textTransform={'uppercase'} fontSize={"sm"} color="grey" fontWeight={"semibold"} letterSpacing={2}>Currently living in</Text>
                        </span>
                        <Text textTransform={'uppercase'} paddingLeft={5} fontWeight={"semibold"} letterSpacing={2}>Kanpur, India</Text>
                        </Box>
                        <Box paddingLeft={20}>
                        <span style={{justifyContent:"flex",display:"flex"}}>
                            <GiMagicHat size={18} color='grey' style={{margin:"3"}}></GiMagicHat>
                            <Text textTransform={'uppercase'} fontSize={"sm"} color="grey" fontWeight={"semibold"} letterSpacing={2}>One of my first designs</Text>
                        </span>
                        <Text textTransform={'uppercase'} paddingLeft={6} fontWeight={"semibold"} letterSpacing={2} _hover={{color:"#362FD9"}}><a href='https://www.facebook.com/photo.php?fbid=977620372352237&set=pb.100003128516256.-2207520000.&type=3'>Poster for school board</a></Text>
                        </Box>
                    </Box>

                    <Box  maxW={'4xl'} display={'flex'} paddingTop={5}>
                        <Box >
                        <span style={{justifyContent:"flex",display:"flex"}}>
                            <BsMusicNoteBeamed size={18} color='grey' style={{margin:"3"}}></BsMusicNoteBeamed>
                            <Text textTransform={'uppercase'} fontSize={"sm"} color="grey" fontWeight={"semibold"} letterSpacing={2}>Favourite Music Artist</Text>
                        </span>
                        <Text textTransform={'uppercase'} paddingLeft={5} fontWeight={"semibold"} letterSpacing={2} _hover={{color:"#362FD9"}}><a href='https://www.youtube.com/theweeknd'>The Weeknd</a></Text>
                        </Box>
                        <Box paddingLeft={10}>
                        <span style={{justifyContent:"flex",display:"flex"}}>
                            <AiOutlineRobot size={18} color='grey' style={{margin:"3"}}></AiOutlineRobot>
                            <Text textTransform={'uppercase'} fontSize={"sm"} color="grey" fontWeight={"semibold"} letterSpacing={2}>Favourite Meme Page</Text>
                        </span>
                        <Text textTransform={'uppercase'} paddingLeft={6} fontWeight={"semibold"} letterSpacing={2} _hover={{color:"#362FD9"}}><a href='https://www.facebook.com/groups/WildGreenMemesForEcologicalFiends'>Wild Green Memes</a></Text>
                        </Box>
                    </Box>
                    
              </VStack>
              <Image src={profile} boxSize={"md"} objectFit={"cover"} borderRadius={"5"}  border={"10px solid #F1F6F9"} backgroundColor={"#F1F6F9"} />

    </Stack>
    </Box>
    <hr></hr>
    <Box display="flex" justifyContent="flex" padding={"6"}>
        <BiMessageSquareDots size={35} style={{paddingTop:"3"}}/>
        <Text fontSize={'2xl'} fontWeight={'bold'} paddingLeft={"4"} letterSpacing={2}>Get to know me</Text>
        <BsArrowDown size={35} style={{paddingTop:"3"}}/>
    </Box>
    <Box display={["block","flex"]} justifyContent={"space-between"} maxW={["sm","8xl"]}>
    <Box paddingLeft={6}   lineHeight={"2.5"}>
        <Text textTransform={'uppercase'} letterSpacing={2} color={"grey"} fontWeight={'semibold'}>Things I like to talk about</Text>
        <ul style={{listStyle:"none", fontWeight:"bold", lineHeight:"2.5"}}>
            <li>Automobiles</li>
            <li>Blockchain</li>
            <li>Cricket</li>
            <li>DeFi</li>
            <li>Design & Art</li>
            
        </ul>
    </Box>
    <Box paddingLeft={"6"} lineHeight={"2.5"}>
        <Text textTransform={'uppercase'} letterSpacing={2} color={"grey"} fontWeight={'semibold'}>Some of my learnings</Text>
        <Text fontWeight={'semibold'} _hover={{color:"#362FD9"}}><a href="/">Being a Blockchain Intern</a></Text>
        <Text fontSize={'sm'} color={"grey"}>My Spritle internship story</Text>
    </Box>
    <Box paddingLeft={"6"} paddingRight={10} lineHeight={"2.5"}>
        <Text textTransform={'uppercase'} letterSpacing={2} color={"grey"} fontWeight={'semibold'}>Get in Touch</Text>
        <ul style={{listStyle:"none", fontWeight:"bold", lineHeight:"2.5"}}>
            <li style={{display:"flex", justifyContent:"flex"}}><BiMailSend size={24} style={{marginRight:"8", marginTop:"8"}}/><Text color={"#362FD9"} _hover={{color:"black"}}>avibhawnani.in@gmail.com</Text></li>
            <li style={{display:"flex", justifyContent:"flex"}}><AiOutlineSchedule size={24} style={{marginRight:"8", marginTop:"8"}}/><Text _hover={{color:"#362FD9"}}><a href="https://calendly.com/avibhawnani/30min">Schedule a Meeting</a></Text></li>
            <li style={{display:"flex", justifyContent:"flex"}}><BsListNested size={24} style={{marginRight:"8", marginTop:"8"}}/><Text _hover={{color:"#362FD9"}}><a href="https://drive.google.com/file/d/1Dm2Dhd_8THuhrqyfCfWAHvjClIwOXLlw/view?usp=drive_link">My Resume</a></Text></li>
            
        </ul>
    </Box>
    </Box>
    
    </section>
    </div>
  )
}

export default About